module.exports = __webpack_public_path__ + "img/nfc-outline-black.25560a42.svg";